import { SERVER_API } from "../../Constant";

export const NodeReportQuery_api = async (
  nodes: string[],
  connections: any[],
  columns: string[],
  filters: any[],
  limit: number = 1000,
  groupBy: string = "",
  aggregate: any = null
) => {
  try {
    const response = await fetch(
      `${SERVER_API}/Reports/node_report_query.php`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ nodes, connections, columns, filters, limit, groupBy, aggregate }),
      }
    );
    return await response.json();
  } catch (error) {
    console.error("Error in NodeReportQuery_api:", error);
    return { success: false, msg: "Network error" };
  }
};
